module.exports = __webpack_public_path__ + "img/pic2.4cd88043.png";